import {regNavn} from "felles/tjenester/tredjepartsTjenestenavn";
import {IController, IModule, IOnChangesObject, IScope} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {dersomChangesInneholder} from "../../../../../../felles/stoettefunk/angularHjelpemetoder";
import {gettextCatalog} from "angular-gettext";
import {PagineringMetadata} from "../../../OppgaverKontroller";

require('./oppgavelistePaginering.scss');

export class OppgavelistePageringKontroller implements IController {

    static registrerKomponent(angular: IModule) {
        angular
          .component('woOppgavelistePagering', {
              bindings: {metadata: '<', utfoerPaginering: '&' },
              controller: OppgavelistePageringKontroller.forInjisering(),
              template: require('./oppgavelistePagering.html')
          });
    }

    static forInjisering() {
        return [
            regNavn.ng.$scope,
            regNavn.gettext.gettextCatalog,
            OppgavelistePageringKontroller
        ]
    }

    constructor(private $scope: IScope, private gettextCatalog: gettextCatalog) {
    }

    utfoerPaginering: (args: {spesifikasjon: l.Pagineringsoffsett}) => void;

    private metadata:PagineringMetadata;
    private sider:Paginertside[] = [];
    private tekst = "";

    // pagineringslogikk

    side(offsett:number) {
        this.utfoerPaginering({spesifikasjon: {offsett: offsett}})
    }

    aktivSide() {
        return this.sider.find(s => s.aktiv);
    }

    harAktivSide() {
        return this.sider.find(s => s.aktiv) !== undefined;
    }

    paginerer() {
        return this.sider.length > 0;
    }

    private genererSider() {
        const antallSider = Math.ceil(this.metadata.totaltAntallOppgaver / this.metadata.maksAntall);
        let sider: Paginertside[] = []

        for (let side = 0; side < antallSider; side++) {
            sider.push({
                side: side + 1,
                offsett: this.metadata.maksAntall * side,
                aktiv: this.metadata.offsett === this.metadata.maksAntall * side
            });
        }

        return sider;
    }
    // $on*
    $onInit() {}

    $onChanges(endringer: IOnChangesObject): void {
        dersomChangesInneholder(endringer, "metadata", metadata => {
            this.metadata = metadata;
            this.sider = this.genererSider();
            this.tekst = this.gettextCatalog.getString("Viser {{fraOppgave}} - {{tilOppgave}} av {{totalAntallOppgaver}} oppgaver", {fraOppgave: this.aktivSide().offsett + 1, tilOppgave: this.aktivSide().offsett + this.metadata.antallOppgaverIPaginering, totalAntallOppgaver: this.metadata.totaltAntallOppgaver})
        });
    }
}

interface Paginertside {
    side: number, offsett:number, aktiv:boolean
}
